import dayjs, { Dayjs } from 'dayjs';
import { DateFormat } from 'types';

export const parseStringIntoDayjsDate: (date: string, format?: DateFormat) => Dayjs = (
    date,
    format = 'YYYY-MM-DD',
) => dayjs(date, format);
